import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getAllCompanyList(data) {
  return request({
    url: URL.batchMove.getAllCompanyList,
    method: 'post',
    data
  })
}

// 复制合作伙伴到指定租户
export function copyCompanyToTenant(data) {
  return request({
    url: URL.batchMove.copyCompanyToTenant,
    method: 'post',
    data
  })
}

export function getAllChargeSchemeList(data) {
  return request({
    url: URL.batchMove.getAllChargeSchemeList,
    method: 'post',
    data
  })
}

// 复制费用方案到指定租户
export function copyChargeSchemeToTenant(data) {
  return request({
    url: URL.batchMove.copyChargeSchemeToTenant,
    method: 'post',
    data
  })
}
